import { render } from "./RegionStrategyTable.vue?vue&type=template&id=74d4d53d&scoped=true"
import script from "./RegionStrategyTable.vue?vue&type=script&lang=js"
export * from "./RegionStrategyTable.vue?vue&type=script&lang=js"

import "./RegionStrategyTable.vue?vue&type=style&index=0&id=74d4d53d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d4d53d"]])

export default __exports__